export default __webpack_public_path__ + "static/media/linkedinMurad.4fa357a0.png";